/**
 * Iconografía centralizada — Fluent UI
 * Mapea todos los iconos de la aplicación a un único estilo
 */

import {
  AppsList20Regular,
  Home20Regular,
  Building20Regular,
  People20Regular,
  Target20Regular,
  Document20Regular,
  CheckmarkCircle20Regular,
  Calendar20Regular,
  Person20Regular,
  Settings20Regular,
  SignOut20Regular,
  Search20Regular,
  ChevronDown20Regular,
  MoreVertical20Regular,
  Dismiss20Regular,
  Add20Regular,
  Edit20Regular,
  Delete20Regular,
  Copy20Regular,
  Eye20Regular,
  EyeOff20Regular,
  Archive20Regular,
  Share20Regular,
  Mail20Regular,
  Phone20Regular,
  Link20Regular,
  Alert20Regular,
  WeatherSunny20Regular,
  WeatherMoon20Regular,
} from '@fluentui/react-icons'

export interface IconProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  className?: string
}

const sizeMap = {
  sm: 16,
  md: 20,
  lg: 24,
}

export const Icons = {
  // Navigation
  Home: (props: IconProps) => <Home20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Dashboard: (props: IconProps) => <AppsList20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Apps: (props: IconProps) => <AppsList20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,

  // Modules
  Empresas: (props: IconProps) => <Building20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Contactos: (props: IconProps) => <People20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Oportunidades: (props: IconProps) => <Target20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Propuestas: (props: IconProps) => <Document20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Tareas: (props: IconProps) => <CheckmarkCircle20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Reuniones: (props: IconProps) => <Calendar20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Usuarios: (props: IconProps) => <Person20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Configuracion: (props: IconProps) => <Settings20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,

  // Actions
  Search: (props: IconProps) => <Search20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Menu: (props: IconProps) => <MoreVertical20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Close: (props: IconProps) => <Dismiss20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  ChevronDown: (props: IconProps) => <ChevronDown20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Add: (props: IconProps) => <Add20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Edit: (props: IconProps) => <Edit20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Delete: (props: IconProps) => <Delete20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Copy: (props: IconProps) => <Copy20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Download: (props: IconProps) => <Add20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  View: (props: IconProps) => <Eye20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  ViewOff: (props: IconProps) => <EyeOff20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Archive: (props: IconProps) => <Archive20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Share: (props: IconProps) => <Share20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Mail: (props: IconProps) => <Mail20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Phone: (props: IconProps) => <Phone20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Link: (props: IconProps) => <Link20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Alert: (props: IconProps) => <Alert20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  SignOut: (props: IconProps) => <SignOut20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  Settings: (props: IconProps) => <Settings20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,

  // Theme
  ThemeLight: (props: IconProps) => <WeatherSunny20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
  ThemeDark: (props: IconProps) => <WeatherMoon20Regular {...props} width={sizeMap[props.size || 'md']} height={sizeMap[props.size || 'md']} />,
}

export default Icons
